import { ISupplierPurchaseContext } from "Interfaces/Providers/SupplierPurchase";
import { SupplierPurchaseContext } from "providers/Supplier/PurchaseProvider";
import { useContext } from "react";

export default function usePurchaseSupplier(): ISupplierPurchaseContext {
  const context = useContext(SupplierPurchaseContext);

  return context;
}
